var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoOnly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M219.27 229.94L207.68 250H92.28L80.7 229.94L69.19 210L57.61 189.94L46.1 170L34.55 150L46.09 130L57.64 110L69.19 130L80.7 149.94L92.28 170L103.8 189.94L115.38 210H161.56L149.98 189.94L138.47 170H184.66L196.17 189.94L207.75 210L219.27 229.94Z",
    fill: "#5AC6C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M265.45 149.94L253.87 170L242.36 189.94L230.85 170L219.27 149.94L207.75 130L196.17 109.94L184.66 90H138.47L149.98 109.94L161.56 130H115.38L103.8 109.94L92.28 90L80.74 70L92.28 50H207.75L219.27 69.94L230.85 90L242.36 109.94L253.94 130L265.45 149.94Z",
    fill: "#5AC6C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOnly);
export default __webpack_public_path__ + "static/media/logo-only.f9ee04266ec14f274640e4eb1038c1d2.svg";
export { ForwardRef as ReactComponent };